import { trigger, state, style, transition, animate } from '@angular/animations';

const ANIMATION_DURATION = 175; // ms transition time for all animations

// animations for DOM element enter/leave: https://www.freecodecamp.org/news/how-to-use-animation-with-angular-6-675b19bc3496/
export const fadeAnimations = [
  trigger('fadeInOut', [
    state('void', style({
      opacity: 0
    })),
    transition('void <=> *', animate(ANIMATION_DURATION)),
  ]),
  trigger('fadeIn', [
    state('void', style({
      opacity: 0
    })),
    transition('void => *', animate(ANIMATION_DURATION)),
  ]),
  trigger('fadeOut', [
    state('void', style({
      opacity: 0
    })),
    transition('* => void', animate(ANIMATION_DURATION)),
  ]),
];